import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private keyLanguage: string = 'userLanguage';
  private _userlanguage: string = '';
  private supportedLanguages: string[] = ['en','fr'];

  constructor(
      private translate : TranslateService
  ) {
    this.initLanguage();
    this.translate.use(this._userlanguage);
    console.log("heere ");
  }

  setLanguage(language: string): void {
    this._userlanguage = language;
    this.translate.use(this._userlanguage);
  }
  get userLanguage(): string {
    return this._userlanguage;
  }

  initLanguage(){
    const value = localStorage.getItem(this.keyLanguage);
    if(value != null){
      this._userlanguage = value;
    }
    else{
      const browserLanguage = navigator.language.split('-')[0];
      if(this.supportedLanguages.includes(browserLanguage)){
        this._userlanguage = browserLanguage;
        localStorage.setItem(this.keyLanguage,browserLanguage);
      }
      else
      {this._userlanguage = 'en' ;
      this.translate.setDefaultLang(this._userlanguage);}

    }
  }

  getAvailableLanguages() :string[] {
    return this.supportedLanguages;
  }

}
